import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-moneda-edit',
  templateUrl: './moneda-edit.component.html',
  styleUrls: ['./moneda-edit.component.css']
})
export class MonedaEditComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=3200;
  resultado:any=[];
  activo:boolean;
  esNuevo:boolean;
  tipo:any=[];
  thisForm = new FormGroup({
    moneda: new FormControl(this.data.item.nombre, [Validators.required, Validators.minLength(3)]),
    tipo: new FormControl(this.data.item.tipo, [Validators.required]),
    valor: new FormControl(this.data.item.valor, [Validators.required]),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<MonedaEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    //console.log(this.data);
    if(this.data){
      if(this.data.id > 0)
        this.esNuevo=false;
      else
        this.esNuevo=true;
      this.activo = this.data.item.act;
    }
    
    this.dataService.getTipos().subscribe(
                      rows => {   
                              this.tipo = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnTipoCargado());     
  }

  fnTipoCargado(){

  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    console.log("Loading: " + this.loading);
    console.log("Change: " + changeLoading);
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="TIPO" && idEl != undefined){
      this.data.item.tipo = idEl;
      this.thisForm.controls["tipo"].setValue(idEl);
    }
  }

  fnDesactivar(){
    this.activo = false;
  }

  fnActivar(){
    this.activo = true;
  }

  fnGuardar(){
    this.loading = true;
    if(this.esNuevo){
      //console.log("GUARDAR");
      //--> Moneda con nombre, mínimo 3 caracteres, selección de tipo y asignación de valor:
      if(this.thisForm.valid)
        this.dataService.insMoneda(this.thisForm.controls["moneda"].value, this.activo, this.thisForm.controls["tipo"].value, this.thisForm.controls["valor"].value).subscribe(
                        rows => {   
                                this.resultado = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnMonedaGuardada());           
      else{
        //console.log(this.thisForm.controls["forma"].errors);
        if(this.thisForm.controls["moneda"].errors){
          if(this.thisForm.controls["moneda"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture un nombre de 'moneda'.", true, false)
          if(this.thisForm.controls["moneda"].errors.minlength){
            if(this.thisForm.controls["moneda"].errors.minlength.actualLength < this.thisForm.controls["moneda"].errors.minlength.requiredLength)
            this.fnMuestraMensaje("ERR", "El nombre de 'moneda' debe contener " + this.thisForm.controls["moneda"].errors.minlength.requiredLength + " o más caracteres.", true, false)
          }
          return;
        }
        if(this.thisForm.controls["tipo"].errors){
          if(this.thisForm.controls["tipo"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture un 'tipo de moneda' (billete/moneda).", true, false);
          return;
        }
        if(this.thisForm.controls["valor"].errors){
          if(this.thisForm.controls["valor"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture un 'valor' para el billete/moneda.", true, false);
          return;
        }
      }
    }
    else{
      //console.log("EDITAR");
      //--> Selección de tipo y asignación de valor:
      if(this.thisForm.valid)
      this.dataService.updMoneda(this.data.id, this.activo, this.thisForm.controls["tipo"].value, this.thisForm.controls["valor"].value).subscribe(
                      rows => {   
                              this.resultado = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnMonedaEditada());    
     
      else{
        if(this.thisForm.controls["tipo"].errors){
          if(this.thisForm.controls["tipo"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture un 'tipo de moneda' (billete/moneda).", true, false);
          return;
        }
        if(this.thisForm.controls["valor"].errors){
          if(this.thisForm.controls["valor"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture un 'valor' para el billete/moneda.", true, false);
          return;
        }
      }
    }
  }

  fnMonedaGuardada(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      this.fnMuestraMensaje("OK", "Registro almacenado", false, true);
    }
    else{
      this.fnMuestraMensaje("ERR", "Error al almacenar registro", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);
    }
  }  

  fnMonedaEditada(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      this.okMsg = "Registro actualizado"
      setTimeout(() => {
        this.okMsg = "";
        this.loading = false;
        this.dialogRef.close();
      }, this.tiempoMsg);
    }
    else{
      this.errMsg = "Error al actualizar registro!"
      setTimeout(() => {
        this.errMsg = "";
        this.loading = false;
      }, this.tiempoMsg);
    }
  }

}

